export type TruncStrOpts = {
	maxChars?: number
}
export const truncStr = (str?: string, options?: TruncStrOpts | number) => {
	const opts = {
		maxChars: typeof options === 'number' ? options : 20,
		...(typeof options === 'number' ? {} : options || {}),
	}
	const { maxChars } = opts

	const truncedStr = str && str.length > maxChars ? `${str.slice(0, maxChars - 3)}...` : str

	return truncedStr || ''
}

export const createDisplayTypeClassName = (displayType: string) => ` _display-type-${displayType}`

export const isStrAnInt = (string?: string) => (string ? !isNaN(parseInt(string)) : false)
